  import React, { useState, useEffect, useRef, useCallback } from 'react';
  import { useLocation } from 'react-router-dom';
  import Loading from "../../Common/Loading"

  const gfn_ShowMessage = (message: string, type: string = 'A'): void => {
    if (!message) return;

    if (type === 'E') {
      console.error(message);
    }

    alert(message);
  };

  const gfn_HidePopup = (): void => {
    if (window.parent) {
      window.parent.postMessage('hidePopup', '*');
    }

    window.close();
  };

  const gfn_SetPopupReturn = (value: string): void => {
    if (window.opener) {
      window.opener.postMessage(
        {
          type: 'popupReturn',
          value,
        },
        '*'
      );
    } else if (window.parent) {
      window.parent.postMessage(
        {
          type: 'popupReturn',
          value,
        },
        '*'
      );
    }
  };

  const gfn_GetClientHeight = (): number => {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    );
  };

  const gfn_Trim = (str: string): string => {
    return str?.trim() || '';
  };

  interface Package {
    packageCode: string;
    packageDesc: string;
    price: string;
    yearStart: string;
    yearEnd: string;
    subjects: string;
    prodIDs: string;
    product: string;
    tmpSubjects: string;
    selected: boolean;
  }

  interface SelectPackagesProps {
    isSans?: boolean;
  }


  const API_BASE_URL =
    process.env.REACT_APP_DOCUMENT_LINK || 'http://127.0.0.1:8000';

    document.body.style.backgroundColor = 'azure';

  const SelectPackages: React.FC<SelectPackagesProps> = ({
    isSans = false,
  }) => {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    // const schoolCode = searchParams.get('SchoolCode') || '';
    const schoolCode = sessionStorage.getItem('school_code') || '';
    const prodIDs = searchParams.get('ProdIDs') || '';
    const errorMesg = searchParams.get('ErrorMesg') || '';

    const [packages, setPackages] = useState<Package[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    const tableDivRef = useRef<HTMLDivElement>(null);

    const GET_PACKAGES_API = `${API_BASE_URL}api/sans/select-packages/`;
    const SAVE_PACKAGES_API = `${API_BASE_URL}api/sans/select-packages/save/`;

    const fn_SelectPackages = useCallback(
      (packageList: Package[]) => {
        if (!prodIDs) return packageList;

        const selectedProdIDs = prodIDs
          .split(',')
          .map((id) => gfn_Trim(id));

        return packageList.map((pkg) => ({
          ...pkg,
          selected: selectedProdIDs.includes(
            gfn_Trim(pkg.packageCode)
          ),
        }));
      },
      [prodIDs]
    );


    useEffect(() => {
      const fetchPackages = async () => {
        try {
          setLoading(true);

          if (errorMesg) {
            gfn_ShowMessage(errorMesg, 'E');
          }

          const params = new URLSearchParams();

          params.append('SchoolCode', schoolCode);

          if (prodIDs) {
            params.append('ProdIDs', prodIDs);
          }

          const response = await fetch(
            `${GET_PACKAGES_API}?${params.toString()}`,
            {
              method: 'GET',
              headers: {
                Accept: 'application/json',
              },
            }
          );

          console.log("Response Status:", response.status);

          const responseText = await response.text();

          console.log("Raw Response:", responseText);

          let data;

          try {
            data = JSON.parse(responseText);
          } catch (e) {
            throw new Error("API did not return valid JSON");
          }

          if (!response.ok) {
            throw new Error(data.error || 'API request failed');
          }

          if (!data.success) {
            throw new Error(data.error || 'Failed to fetch packages');
          }

          const updatedPackages = fn_SelectPackages(
            data.packages || []
          );

          setPackages(updatedPackages);

          // Set dynamic height
          setTimeout(() => {
            if (tableDivRef.current) {
              tableDivRef.current.style.height = `${gfn_GetClientHeight() - 60
                }px`;
            }
          }, 100);
        } catch (err: any) {
          console.error(err);
          setError(err.message || 'Something went wrong');
        } finally {
          setLoading(false);
        }
      };

      fetchPackages();
    }, [
      GET_PACKAGES_API,
      schoolCode,
      prodIDs,
      errorMesg,
      fn_SelectPackages,
    ]);


    useEffect(() => {
      if (error) {
        gfn_ShowMessage(error, 'E');
      }
    }, [error]);


    const getSelectedRows = (): number[] => {
      return packages
        .map((pkg, index) =>
          pkg.selected ? index + 1 : null
        )
        .filter(Boolean) as number[];
    };

    const getCellText = (
      rowIndex: number,
      colIndex: number
    ): string => {
      const pkg = packages[rowIndex - 1];

      if (!pkg) return '';

      switch (colIndex) {
        case 1:
          return pkg.packageCode;
        case 2:
          return pkg.packageDesc;
        case 3:
          return pkg.product;
        case 4:
          return pkg.price;
        case 5:
          return pkg.yearStart;
        case 6:
          return pkg.yearEnd;
        case 7:
          return pkg.subjects;
        case 8:
          return pkg.prodIDs;
        case 9:
          return pkg.tmpSubjects;
        default:
          return '';
      }
    };

    const toggleRowSelection = (index: number) => {
      setPackages((prev) =>
        prev.map((pkg, idx) =>
          idx === index
            ? {
              ...pkg,
              selected: !pkg.selected,
            }
            : pkg
        )
      );
    };


    const fn_AddPackages = async () => {
      try {
        const selectedRows = getSelectedRows();

        if (selectedRows.length === 0) {
          gfn_ShowMessage(
            'Please select at least one package.'
          );
          return;
        }

        let temp = '';
        let temp1 = '';

        for (const rowIndex of selectedRows) {
          if (
            gfn_Trim(getCellText(rowIndex, 1)) === '0'
          ) {
            gfn_ShowMessage('Invalid package.');
            return;
          }

          temp1 = '';

          for (let j = 1; j <= 8; j++) {
            if (temp1 !== '') {
              temp1 += '#-#';
            }

            temp1 += getCellText(rowIndex, j);
          }

          if (temp1 !== '') {
            if (temp !== '') {
              temp += '|';
            }

            temp += temp1;
          }
        }

        // Return selected packages to parent
        gfn_SetPopupReturn(temp);

        const selectedPackageCodes = packages
          .filter((pkg) => pkg.selected)
          .map((pkg) => pkg.packageCode);

        const saveResponse = await fetch(
          SAVE_PACKAGES_API,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              schoolCode,
              selectedPackages: selectedPackageCodes,
            }),
          }
        );

        const saveData = await saveResponse.json();

        if (!saveResponse.ok || !saveData.success) {
          throw new Error(
            saveData.error ||
            'Failed to save selected packages'
          );
        }

        gfn_HidePopup();
      } catch (err: any) {
        console.error(err);
        gfn_ShowMessage(
          err.message || 'Failed to add packages',
          'E'
        );
      }
    };


    const fn_Close = () => {
      gfn_HidePopup();
    };


    if (loading) {
      return (
        <div
          style={{
            padding: '30px',
            textAlign: 'center',
          }}
        >
<Loading />
        </div>
      );
    }


    return (
      <div style={{ margin: 0 }}>
        <form id="form1" style={{ margin: 0 }}>
          <div
            style={{
              padding: '8px',
              textAlign: 'center',
            }}
          >
            {/* Title */}
            <div
              style={{
                marginBottom: '12px',
                fontWeight: 'bold',
                fontSize: '18px',
              }}
            >
              {isSans
                ? 'SANS - Select Packages'
                : 'Select Packages'}
            </div>

            {/* Table */}
            <div
              ref={tableDivRef}
              style={{
                overflow: 'auto',
                border: '1px solid #ccc',
                backgroundColor: '#fff',
                marginBottom: '10px',
              }}
            >
              <table
                cellPadding="2"
                cellSpacing="0"
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                }}
              >
                <thead>
                  <tr
                    style={{
                      backgroundColor: '#f0f0f0',
                    }}
                  >
                    <th>&nbsp;</th>
                    <th>PackageID</th>
                    <th>Package Name</th>
                    <th>Product(s)</th>
                    <th>Price</th>
                    <th>Start Year</th>
                    <th>End Year</th>
                    <th>Subject</th>
                    <th>ProdIDs</th>
                    <th>Subjects</th>
                  </tr>
                </thead>

                <tbody>
                  {packages.length > 0 ? (
                    packages.map((pkg, index) => (
                      <tr
                        key={`${pkg.packageCode}-${index}`}
                        onClick={() =>
                          toggleRowSelection(index)
                        }
                        style={{
                          cursor: 'pointer',
                          backgroundColor:
                            index % 2 === 0
                              ? '#fff'
                              : '#f9f9f9',
                        }}
                      >
                        <td
                          style={{
                            border: '1px solid #ddd',
                            padding: '8px',
                            textAlign: 'center',
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={pkg.selected}
                            onChange={(e) => {
                              e.stopPropagation();
                              toggleRowSelection(index);
                            }}
                          />
                        </td>

                        <td>{pkg.packageCode}</td>

                        <td>{pkg.packageDesc}</td>

                        <td
                          dangerouslySetInnerHTML={{
                            __html:
                              pkg.product || '&nbsp;',
                          }}
                        />

                        <td>{pkg.price}</td>

                        <td>{pkg.yearStart}</td>

                        <td>{pkg.yearEnd}</td>

                        <td>{pkg.subjects}</td>

                        <td>{pkg.prodIDs}</td>

                        <td
                          dangerouslySetInnerHTML={{
                            __html:
                              pkg.tmpSubjects ||
                              '&nbsp;',
                          }}
                        />
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={10}
                        style={{
                          textAlign: 'center',
                          padding: '20px',
                        }}
                      >
                        No packages found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Buttons */}
            <div style={{ marginTop: '15px' }}>
              <input
                type="button"
                value={
                  isSans
                    ? 'Add SANS Packages'
                    : 'Add Packages'
                }
                onClick={fn_AddPackages}
                style={{
                  cursor: 'pointer',
                  width: '140px',
                  marginRight: '10px',
                }}
              />

              <input
                type="button"
                value="Close"
                onClick={fn_Close}
                style={{
                  cursor: 'pointer',
                  width: '110px',
                }}
              />
            </div>

            {/* Hidden Field */}
            <input
              type="hidden"
              value={packages
                .filter((p) => p.selected)
                .map((p) => p.packageCode)
                .join(',')}
            />
          </div>
        </form>
      </div>
    );
  };

  export default SelectPackages;